import i18n from 'i18next';

export const GAME_EDITOR_WIDTH = 720;
export const KEY_VISION_HEIGHT = 400;
export const GAME_EDITOR_DESIGN_WIDTH = 592;
const DEFAULT_EDITOR_PRIZE_CARD_NUMBER = 4;
// 網頁背景
export const PICK_THE_PRIZE_BACKGROUND_IMAGE_PC_URL =
    'https://assets.fevercdn.com/promotion/img/Slots_BG_Desktop.png';
export const PICK_THE_PRIZE_BACKGROUND_IMAGE_MB_URL =
    'https://assets.fevercdn.com/promotion/img/Slots_BG_Mobile.png';

export const PRIZE_STATE = {
    SELECTABLE: 'selectable', // 可以被選取(領取)
    SELECTED: 'selected', // 已選取
    RECEIVE: 'received', // 已領取
    RUNOUT: 'isRunout', // 已發完
    LOCKED: 'isLocked', // 已達上限
    NO_DATA: 'noData'
};

export const GAME_STATE = {
    NO_DATA: 'noData', // 初始化狀態
    SELECTABLE: 'selectable', // 還有獎品可以選
    MAXIMUM: 'maximum', // 獎品已選滿
    PENDING: 'pending', // 等待處理獎品領取
    WAITING: 'waiting', // 等待處理意外情況，當獎品都沒了
    COMPLETE: 'complete' // 結束領取
};

export const GAME_TRANSITIONS = {
    ENTER: 'ENTER',
    SUBMIT: 'SUBMIT',
    VERIFY: 'VERIFY',
    COMPLETE: 'COMPLETE',
    PLAYED: 'PLAYED',
    SELECT: 'SELECT',
    CANCEL: 'CANCEL',
    CHECK: 'CHECK'
};

export const PRIZE_TRANSITIONS = {
    FETCH: 'FETCH',
    LOCKED: 'LOCKED',
    RECEIVE: 'RECEIVE',
    RUNOUT: 'RUNOUT',
    SELECT: 'SELECT',
    CANCEL: 'CANCEL',
    INIT: 'INIT'
};

export const DEFAULT_GAME_STATE = {
    state: GAME_STATE.SELECTABLE,
    context: {
        restLimitation: 1
    }
};

const DEFAULT_PRIZE_INFO = {
    key: 0,
    title: i18n.t('label.pick_the_prize.prize_card.defalut.title'),
    caption: i18n.t('label.pick_the_prize.prize_card.defalut.desc'),
    imageSrc: 'https://assets.fevercdn.com/promotion/img/prizeImg.jpg'
};

const DEFAULT_PRIZE_STATUS = {
    state: PRIZE_STATE.SELECTABLE,
    context: {
        key: 0,
        isLimited: true,
        restQuantity: 0,
        totalQuantity: 0
    },
    selectedPrizes: 0
};

export const DEFAULT_PRIZE_INFO_LIST = new Array(DEFAULT_EDITOR_PRIZE_CARD_NUMBER)
    .fill(DEFAULT_PRIZE_INFO)
    .reduce((result, current, index) => {
        result[index] = {
            ...current,
            key: index
        };
        return result;
    }, {});

export const DEFAULT_PRIZE_STATUS_LIST = new Array(DEFAULT_EDITOR_PRIZE_CARD_NUMBER)
    .fill(DEFAULT_PRIZE_STATUS)
    .reduce((result, current, index) => {
        result[index] = {
            ...current,
            context: {
                ...current.context,
                key: index
            }
        };
        return result;
    }, {});
